import { useFilters, useHomeSearchParams, useI18N } from "common/hooks";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { PiFunnelSimple } from "react-icons/pi";

function NearbyFilterbar(props: { onFilters: () => void }) {
  const { setFiltersState, filtersState } = useFilters();
  const [applyFilters, setApplyFilters] = useState(false);
  const { setHomeSearchParams } = useHomeSearchParams();
  const i18n = useI18N();

  useEffect(() => {
    if (applyFilters) {
      setApplyFilters(false);
      const types = filtersState.selectedBusinessTypes.join("|");
      if (types.length <= 0) {
        //see if other filters are applied
        const isFiltersApplied =
          (filtersState.filtersApplied?.accessibilities.length || 0) > 0 ||
          filtersState?.openingHoursSelected;
        setFiltersState({
          ...filtersState,
          isFiltersApplied: isFiltersApplied,
          filtersApplied: isFiltersApplied
            ? {
                types,
                accessibilities:
                  filtersState.filtersApplied?.accessibilities || "",
                showVenueOptions:
                  filtersState.filtersApplied?.showVenueOptions || "",
              }
            : null,
        });
      } else {
        setFiltersState({
          ...filtersState,
          isFiltersApplied: true,
          filtersApplied: {
            types,
            accessibilities: filtersState.filtersApplied?.accessibilities || "",
            showVenueOptions:
              filtersState.filtersApplied?.showVenueOptions || "",
          },
        });
      }
      setHomeSearchParams((prev) => {
        return {
          ...prev,
          types,
        };
      });
    }
  }, [filtersState, applyFilters, setFiltersState, setHomeSearchParams]);

  return (
    <div className="flex flex-row mb-5">      
      <div className="bg-primary-150 w-[2px] mx-6" />
      <div className="">
        <button
          onClick={() => {
            props.onFilters();
          }}
          role="button"
          className={cn(
            "flex items-center py-[10px] rounded-[12px] px-4",
            filtersState.isFiltersApplied
              ? "bg-secondary-400 border border-secondary-400"
              : "bg-primary-100 dark:bg-[#37354D] border border-primary-100 dark:border-[#37354D]",
            "focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
          )}
          aria-label={
            filtersState.isFiltersApplied
              ? `${i18n.get("filters")} selected`
              : `${i18n.get("filters")}`
          }
        >
          <div className={cn("w-6 h-6 relative")} aria-hidden="true">
            <PiFunnelSimple
              size={22}
              className={cn(
                "text-primary-900",
                filtersState.isFiltersApplied ? "text-primary-900" : "text-primary-900 dark:text-[#EEEDFB]"
              )}
            />
          </div>

          <span
            aria-hidden="true"
            className={cn(
              "button-small-semi-bold hidden md:block text-primary-900 ml-2 flex-row truncate",
              filtersState.isFiltersApplied ? "text-primary-900" : "text-primary-900 dark:text-[#EEEDFB]"
            )}
          >
            {i18n.get("filters")}
          </span>
        </button>
      </div>

     
    </div>
  );
}

export default NearbyFilterbar;
